import {createSlice} from "@reduxjs/toolkit";
import {fetchConfig, updateConfig} from "../thunks/configThunks";

const initialState = {
  config: {
    honorariumScheduleDay: 20,
    pricePerKilometer: 10,
    expenseScheduleDay: 5,
  },
  loading: false,
  error: null,
  success: null,
};

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    clearConfigSuccess: (state) => {
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Config
      .addCase(fetchConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.config = action.payload?.data || initialState.config;
      })
      .addCase(fetchConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update Config
      .addCase(updateConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(updateConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.config = action.payload?.data || state.config;
        state.success =
          action.payload?.message || "Config updated successfully";
      })
      .addCase(updateConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = null;
      });
  },
});

export const conAction = configSlice.actions;
export const conReducer = configSlice.reducer;
